export const getBundleSaga = () => ({
    type: 'TEST_MULTI_SAGA',
})

export const updatePhone = (params) => ({
    type: 'UPDATE_PHONE',
    params
})

export const useYourOwnNumber = (params) => ({
    type: 'USE_YOUR_OWN_NO',
    params,
});

export const fetchJointOfferInfo = (tn) => ({
    type: 'FETCH_JOINT_OFFER_INFO',
    tn,
});

export const getYellowPageHeadings = (params) => ({
    type: 'GET_YELLOW_PAGE_HEADING',
    params
})
export const emptyYellowPageResponse = () => ({
    type: 'GET_YELLOW_PAGE_RES',
    data: []
})

export const getSelectedBundleInfo = (params, infoParams) => ({
    type: 'GET_SELECTED_BUNDLE_INFO',
    params,
    infoParams
})

export const getinternetFlowData = (params) => ({
    type: 'GET_INTERNET_DATA',
    params
})

export const updateForBundle = (params) => ({
    type: 'UPDATE_ALL_SELECTED_PLANS',
    params
})

export const updatePhoneServiceType = (params) => ({
    type: 'UPDATE_PHONE_SERVICES',
    params
})



export const updateFlowTypeStatus = (params) => ({
    type: 'SET_FLOW_STATUS',
    params
});

export const updateSelectedPhoneEquipments = (params) => ({
    type: 'SELECTED_PHONE_EQUIPMENT',
    params
});

export const postInternetData = (params) => ({
    type: 'POST_INTERNET_DATA',
    params
})

export const getFiosData = () => ({
    type: 'GET_FIOS_DATA_REQUEST',
})

export const getSABdvData = (params) => ({
    type: 'GET_SA_BDV',
    params
})

export const resetBDVSelection =(data) =>({
    type: 'Select_BDVBundle_ON_Internet',
    data
})
export const IsCheckoutEnableforBDV =(data) =>({
    type: 'SET_CHECKOUT_ENABLE_BDV',
    data
})
export const call911Service =(data) =>({
    type: '911_Service_ACCEPTED',
    data
})


export const fetchCustomizeProducts = () => ({
    type: 'FETCH_CUSTOMIZE_PRODUCTS'
})
export const getCustomizeFiosBdvData = (params) => ({
    type: 'GET_CUSTOMIZE_FIOS_BDV_REQUEST',
    params
})
export const getCustomizeHSIPhoneBundleInfo = (params) => ({
    type: 'GET_CUSTOMIZE_HSI_PHONE_REQUEST',
    params
})
export const resetIsPhone = (phoneValue) => ({
    type: 'IS_Phone',
    data: phoneValue
});
export const getPreferredVoiceData = (params) => ({
    type: 'GET_PREFERRED_VOICE',
    params
})
export const setPreviousState = (savedStateData) => ({
    type: 'SAVE_STATE_DETAILS',
    data: savedStateData
});

export const getFloatCart = () => ({
    type: 'GET_FLOAT_CART'
});

export const jointOfferAttempted = (val) => ({
    type: 'JOINT_OFFER_ATTEMPTED',
    data: val
});

export const getFiosTv = (params = {}) => ({
    type: 'GET_FIOS_TV_REQUEST',
    params
});

export const updateFiosTv = (params) => ({
    type: 'UPDATE_FIOS_TV',
    params
});
export const getRetrieveOrder = (params) => ({
    type: 'GET_RETRIEVE_ORDER',
    params
});

export const getRetrieveCartInfo = (data) => ({
    type: 'GET_RETRIEVE_CART_INFO',
    data
});
export const saveAddTVSubHeader = (data) => ({
    type: 'SAVE_ADD_TV_SUBHEADER',
    data
});

export const setBannerInfo = (data) => ({
    type: 'SET_BANNER_INFO',
    data
});



export const removeBannerDefaultSelection = (data) => ({
    type: 'REMOVE_INTERNET_BANNER_SPEED',
    data
});


export const updateTVViewType = (data) => (
    {
        type: 'UPDATE_TV_VIEW',
        data
    });
export const setNavPrice = (data) => ({
    type: 'SAVE_NAV_PRICE',
    data
});

export const removeBannerPhoneDefaultSelection = (data) => ({
    type: 'REMOVE_PHONE_BANNER_DATA',
    data
});

export const updateDoubleDataBDV = (params) => ({
    type: 'POST_DOUBLE_DATA_BDV_REQUEST',
    params
});

export const updateDoubleDataPhone = (params) => ({
    type: 'POST_DOUBLE_DATA_PHONE_REQUEST',
    params
});


export const isFlowChanged = (params) => ({
    type: 'IS_FLOW_CHANGED',
    params
});

export const isReverseFlow = (params) => ({
    type: 'IS_REVERSE_FLOW',
    params
});

export const updateTripleDataPhone = (params) => ({
    type: 'POST_TRIPLE_DATA_PHONE_REQUEST',
    params
});

export const updateDoubleDataTv = (params) => ({
    type: 'POST_DOUBLE_DATA_TV_REQUEST',
    params
});

export const updateTripleDataBDVTv = (params) => ({
    type: 'POST_TRIPLE_DATA_BDV_TV_REQUEST',
    params
});

export const updateTripleDataPhoneTv = (params) => ({
    type: 'POST_TRIPLE_DATA_PHONE_TV_REQUEST',
    params
});


export const updateDoubleHSIPhone = (params) => ({
    type: 'POST_DOUBLE_HSI_PHONE_REQUEST',
    params
});

export const updateSelectedNonDoBundleInfoDetails = (params) => ({
    type: 'SET_SELECTED_NON_DO_BUNDLE_PLANS',
    params
});

export const updateCart = (data) => ({
    type: 'UPDATE_CART',
    data
});

export const addTechTeamUsers = (data) => ({
    type: 'ADD_TECHTEAM_USERS',
    data
});



export const resetBannerTvInfo = (data) => ({
    type: 'REMOVE_TV_BANNER_DATA',
    data
});

export const resetBundleProperties = () => ({
    type: 'RESET_BUNDLE_CONVERSION_PROPERTIES',
});


export const setSelectedContract = (data) => ({
    type: 'SET_CONTRACT_TYPE',
    data
});

export const redirectLBOPage = (message) => ({
    type: 'REDIRECT_TO_LBO',
    message
});

export const setSelectedProductType = (data) => ({
    type: 'SET_SELECTED_PRODUCT_TYPE',
    data
})

export const getChatInfo = (params) => ({
    type: 'GET_CHAT_INFO',
    params,
})

export const updateSelectedInternetPlanID = (internetPlanID) => ({
    type: 'UPDATE_INTERNET_PLAN_ID',
    internetPlanID
})

export const updateInternetPlanID = (internetPlanID) => ({
    type: 'UPDATE_INTERNET_ID',
    internetPlanID
})
export const UpdatePremiumSupportSelection = (data) => ({
    type: 'UPDATE_PREMIUM_SUPPORT_SELECTION',
    data
})

export const updateSelectedPlanDetails = (data) => ({
    type: 'UPDATE_SELECTED_PLAN_DETAILS',
    data
})

export const resetSelectedPlanDetails = () => ({
    type: 'RESET_SELECTED_PLAN_DETAILS',
})

export const getYahooLocalWorksCategoriesAndAddress = () => ({
    type: 'GET_YAHOO_CATEGORIES'
});


export const checkYahooEligibility = (params, showAddService) => ({
    type: 'YAHOO_ELIGIBILITY_CHECK',
    payload: {params, showAddService}
});

export const clearEligibilityForm = () => ({
    type: 'CLEAR_YAHOO_FORM'
});

export const clearYahooEligibilityResponse = () => ({
    type: 'CLEAR_YAHOO_ELIGIBILITY_RESPONSE'
});

export const setBundleOptionSelections = data => ({
    type: 'SET_BUNDLEOPTIONS_SELECTIONS',
    data
});

export const updateSelectedInternetPlan = params => ({
    type: 'UPDATE_SELECTED_INTERNET_PLAN',
    params
});

export const updatePageLoadType = (data) => ({
    type: 'UPDATE_PAGELOAD_TYPE',
    data
});

export const updateServiceCallOpt = (data) => ({
    type: 'UPDATE_SERVICE_CALL_OPT',
    data
});
export const updateIsServiceCallCheckboxSelected = (data) => ({
    type: 'UPDATE_IS_SERVICE_CALL_CHECKBOX_SELECTED',
    data
});

export const updateServiceCallReq = (data) => ({
    type: 'UPDATE_SERVICES_CALL_REQ',
    data
});

export const updateIsCheckoutPageVisited = (data) => ({
    type: 'UPDATE_CHECKOUTPAGE_VISIT_FLAG',
    data
});

export const saveTVPlan = (data) => ({
    type: 'SAVE_TV_PLAN',
    data
});


export const updateIsSaveCartPageVisited = (data) => ({
    type: 'UPDATE_SAVECARTPAGE_VISIT_FLAG',
    data
});

export const updateIsSavedCartOfferApplied = (data) => ({
    type: 'UPDATE_IS_SAVED_CART_OFFER_APPLIED',
    data
});

export const updateIsETFBuyOutQualified = (data) => ({
    type: 'UPDATE_IS_ETF_BUY_OUT_QUALIFIED',
    data
});


export const setNewEquipment = data => ({
    type: 'SET_NEW_EQUIPMENT_SELECTION',
    data
});

export const setNewBISSelection = data => ({
    type: 'SET_NEW_BIS_SELECTION',
    data
});

export const setSmallBISLimitation = data => ({
    type: 'SET_SMALL_BIS_LIMITATION',
    data
});

export const disableVasProductFlag = data => ({
    type: 'DISABLE_VAS_PRODUCT',
    data
});

export const setNewBisPreferSelection = data => ({
    type: 'SET_NEW_BIS_PREFER_SELECTION',
    data
});

export const setSelectedIpID = (data) => ({
    type: 'SET_SELECTED_IP_ID',
    data
});

export const setNewIPSelection = data => ({
    type: 'SET_NEW_IP_SELECTION',
    data
});

export const setBlockIPSelection = data => ({
    type: 'SET_BLOCK_IP_SELECTION',
    data
});
export const showBlockIPSelection = data => ({
    type: 'SHOW_BLOCK_IP_SELECTION',
    data
});


export const setTVRecordingSelection = data => ({
    type: 'SET_TV_RECORDING_SELECTION',
    data
});

export const resetTVRecording = data => ({
    type: 'RESET_TV_RECORDING_SELECTION',
    data
});
export const setTVRecordingSelectionvalue = data => ({
    type: 'SET_TV_RECORDING_SELECTION_VALUE',
    data
});

export const resetTVRecordingSelectionvalue = data => ({
    type: 'RESET_TV_RECORDING_SELECTION_VALUE',
    data
});

export const setNewTSPSelection = data => ({
    type: 'SET_NEW_TSP_SELECTION',
    data
});

export const setNewTechTeamSelection = data => ({
    type: 'SET_NEW_TECHTEAM_SELECTION',
    data
});

export const showNewTechTeamSelection = data => ({
    type: 'SHOW_NEW_TECHTEAM_SELECTION',
    data
});

export const setTechTeamData = data => ({
    type: 'SET_TECHTEAM_FORM_DATA',
    data
});

export const setNewTechTeamSubmitted = data => ({
    type: 'SET_SUBMITTED_TECHTEAM_SELECTION',
    data
});


export const setVzCloudSelection = data => ({
    type: 'SET_NEW_VERIZON_CLOUD_SELECTION',
    data
});

export const setYlwSelection = data => ({
    type: 'SET_NEW_YAHOO_LOCAL_WORKS_SELECTION',
    data
});

export const setYlwData = data => ({
    type: "SET_YLW_DATA",
    data
})

export const setPhoneCompletionStatus = data => ({
    type: 'SET_PHONE_COMPLETION_STATUS',
    data
});

export const setNooflinesCompletionStatus = data => ({
    type: 'SET_NOOFLINES_COMPLETION_STATUS',
    data
});

export const setNewNoOfLines = data => ({
    type: 'SET_NEW_NOOFLINES_SELECTION',
    data
});

export const setCheckEquipmentAdded = data => ({
    type: 'SET_CHECK_EQUIPMENT_ADDED',
    data
});

export const setStandardLineSelection = data => ({
    type: 'SET_NEW_STANDARDLINE_SELECTION',
    data
});

export const setNewPhoneEquipmentsSelection = data => ({
    type: 'SET_NEW_PHONEQUIPMENT_SELECTION',
    data
});

export const updateServiceReqInfo = (data) => ({
    type: "UPDATE_SERVICE_REQ_INFO",
    data
});

export const updateServiceRequirementCallInfo = (data) => ({
    type: 'UPDATE_SERVICES_REQ_CALL_INFO',
    data
});

export const setNewDirectoryListingSelection = data => ({
    type: 'SET_NEW_DIRECTORYLISTING_SELECTION',
    data
});

export const setAccordianStatus = data => ({
    type: 'SET_NEW_ACCORDIAN_STATUS',
    data
});

export const resetPreviousSelections = () => ({
    type: 'RESET_SELECTIONS_ON_CHECKBOX_CLICK',
});

export const resetAddTVSubHeader = () => ({
    type: 'RESET_ADD_TV_SUBHEADER',
});


export const resetWinBackTNData =() =>({
    type : "RESET_WIN_BACK_TN"
})
/*** joint offer message disable ***/

export const disableJointOffer = (data) => ({
    type: 'JOINT_OFFER_DISABLE',
    data
});

export const updateBlueJeansMeetingStandardCheck = (data) => ({
    type: 'UPDATE_BLUEJEANS_MEETINGS_STANDARD_CHECK',
    data
});

export const updateBlueJeansSelectionInStore = (productID) => ({
    type: 'UPDATE_BLUEJEANS_SELECTION',
    data: productID
});

export const updateBlueJeansLicenseSelectionInStore = (noOfLicenses) => ({
    type: 'UPDATE_BLUEJEANS_LICENSE_SELECTION',
    data: noOfLicenses
});

export const setIsRouterSelected = (data) => ({
    type: 'SET_ISROUTER_SELECTED',
    data
});

export const setIsRouterFirstTime = (data) => ({
    type: 'SET_ISROUTER_FIRSTTIME',
    data
});

export const getFlexSelection = (data) => ({
    type: 'GET_FLEX_SELECTION',
    data
});

export const setCheckOutProgress = (data) => ({
    type: 'HAS_CHECKOUT_DETAILS_RESPONSE',
    data
});
export const updateSerivcesInCart = (data) => ({
    type: 'UPDATE_SERVICES_IN_CART',
    data
});

export const updateSerivcesInCartbyBDV = (data) => ({
    type: 'UPDATE_SERVICES_IN_CART_BDV',
    data
});

export const saveBusinessInfo =(data) =>({
    type: "SAVE_BUSINESS_INFO",
    data
});


export const setTVOrderInfo = (data) => ({
    type: 'SET_TV_ORDER',
    data
});

export const setScartId = (data) => ({
    type: 'SET_SCART_ID',
    data
});

export const setTvHdSetupSelection = (data) => ({
    type: 'SET_HD_SETUP_SELECTION',
    data
});

export const setNumberOfLinesComplete = (data) => ({
    type: 'SET_NUMBEROFLINES_COMPLETE',
    data
});

export const postUIEventLog = (data) => ({
    type: 'POST_EVENT_LOGGING',
    data
});

export const saveViewSelection = (data) => ({
    type: 'SAVE_VIEW_SELECTION',
    data
});

export const UpdateJointOfferCount = (data) => ({
    type: 'JOINT_OFFER_AVAILABILITY_RESPONSE',
    data
});

export const getQualificationDetails = (params) => ({
    type: 'GET_QUALIFICATION_DETAILS',
    params
});

export const GetBDVTNs = (data, callback) => ({
    type: 'GET_BDV_TNS',
    data,
    callback
});

export const updateBdvTNCount = (data) => ({
    type: 'SET_BDV_TN_COUNT',
    data
});

export const internetFlowCompleted = (data) => ({
    type: 'INTERNER_FLOW_COMPLETED',
    data
});
export const enableRouterNotification = (data) => ({
    type: 'ENABLE_ROUTER_NOTIFICATION',
    data
});
export const enablePhoneNotification = (data) => ({
    type: 'ENABLE_PHONE_NOTIFICATION',
    data
});
export const enableEquipmentNotification = (data) => ({
    type: 'ENABLE_EQUIPMENT_NOTIFICATION',
    data
});
export const setBdvwPhoneLine = (data) => ({
    type: 'SET_BDVW_PHONE_LINES',
    data
});
export const setBdvwEquipmnetPhone = (data) => ({
    type: 'SET_SELECTED_BDVW_EQUIPMENTS_PHONE',
    data
});
export const setEnableEquipment = (data) => ({
    type: 'SET_ENABLE_EQUIPMENT_SECTION_BDVW',
    data
});
export const setEnableFeatures = (data) => ({
    type: 'SET_ENABLE_FEATURE_SECTION_BDVW',
    data
});
export const setEnableWebexSection = (data) => ({
    type: 'SET_ENABLE_WEBEX_SECTION_BDVW',
    data
});
export const setEnableSelectLinesSection = (data) => ({
    type: 'SET_ENABLE_SELCTLINES_SECTION_BDVW',
    data
});
export const setFeaturesCheckedList = (data) => ({
    type: 'SET_FEATURES_CHECKED_BDVW',
    data
});
export const setEmailValidationFailureCount = (actionType) => ({
    type: 'SET_EMAIL_VALIDATION_FAILURE_COUNT',
    actionType
});
export const setNewRouterSelected = (data)=>({
    type: 'SET_ROUTER_SELECTED_3.0',
    data
})

export const setRouterErrorNotification = (data)=>({
    type: 'SET_ROUTER_ERROR_NOTIFICATION_3.0',
    data
})

export const setSelectedStaticIP = (data)=>({
    type: 'SET_SELECTED_STATIC_IP_NEW_3.0',
    data
})
export const setSelectedTVViewingOption = (data)=>({
    type: 'SET_SELECTED_TV_VIEWING_OPTION',
    data
})
export const setSelectedBarPeopleFOC = (data)=>({
    type: 'SET_SELECTED_BAR_PEOPLE_FOC',
    data
})

export const setStoreOldId = (data)=>({
    type: 'SET_STORE_OLD_ID',
    data
})

export const setStoreEquipment = (data)=>({
    type: 'SET_STORE_EQUIPMENT',
    data
})

export const setStoreChannel = (data)=>({
    type: 'SET_STORE_CHANNEL',
    data
})

export const setStoreSubTitle = (data)=>({
    type: 'SET_STORE_SUBTITLE',
    data
})
export const updateBDVEquipmentList=(data)=>({
    type:"UPDATE_BDV_EQUIPMENTS",
    data
});
export const setTvChannelInfo = (data)=>({
    type:"SET_VDS3_CHANNEL_TYPE",
    data
})
export const enableTheInternetNotification=(data)=>({
    type: "ENABLE_INTERNET_NOTIFICATION",
    data
})
export const setIpSectionSelected=(data)=>({
    type: "SET_IP_SECTION_SELECTED",
    data
})
export const setRouterAccordianStatus=(data)=>({
    type: "SET_ROUTER_ACCORDIAN",
    data
})
export const updatePhoneEquipmentSelectionFlag = (data) => ({
    type: "IS_PHONE_EQUIPMENT_SELECTION_DONE",
    data
})
export const setPlanTileSelected=(data)=>({
    type: "SET_PLAN_TILE_SELECTED",
    data
})
export const setExtraNumberOfRouters = (data) => ({
    type: "SET_ROUTER_NOS",
    data
})
export const setIsOwnerRouterSelected = (data) => ({
    type: "SET_IS_OWNER_ROUTER_SELECTED",
    data
})
export const setVcgCheckAvailDone = (data) => ({
    type: "SET_VCG_CHECK_AVAIL_DONE",
    data
})